export const STATUS_META = {
  rosso: { label: "Scaduto", cls: "badge-rosso", row: "row-rosso" },
  arancione: { label: "Entro 30 giorni", cls: "badge-arancione", row: "row-arancione" },
  giallo: { label: "Entro 60 giorni", cls: "badge-giallo", row: "row-giallo" },
  verde: { label: "Oltre 60 giorni", cls: "badge-verde", row: "row-verde" },
};

export function statusMeta(status) {
  return STATUS_META[status] || { label: "—", cls: "", row: "" };
}

export function giorniLabel(giorni) {
  if (giorni === null || giorni === undefined) return "—";
  if (giorni < 0) return `${Math.abs(giorni)} gg fa`;
  if (giorni === 0) return "oggi";
  return `tra ${giorni} gg`;
}
